//For Base URL and User Authentication
const BASE_URL = "https://api.automa.id/api";
// const BASE_URL = "api.automa.id:8080/api";

const TRANSPORTER_URL = BASE_URL + '/transporter'
const REPORT_BASE_URL = TRANSPORTER_URL + '/report'
const TRANSPORTER_SHARE_TRACK_URL = REPORT_BASE_URL + '/check/in/log/share'


const NURSE_BASE_URL = BASE_URL + '/nurse'
const NURSE_ROOM_LIST_URL = NURSE_BASE_URL + '/room/list'
const NURSE_ROOM_UPDATE_URL = NURSE_BASE_URL + '/room/update'


export {
    TRANSPORTER_SHARE_TRACK_URL,

    NURSE_ROOM_LIST_URL,
    NURSE_ROOM_UPDATE_URL

}


// WEBPACK FOOTER //
// ./src/redux/config/links.jsx